__turbopack_context__.v({
  "alertError": "toast-module-scss-module__bXCbOq__alertError",
  "alertSuccess": "toast-module-scss-module__bXCbOq__alertSuccess",
  "dismissButton": "toast-module-scss-module__bXCbOq__dismissButton",
  "dismissible": "toast-module-scss-module__bXCbOq__dismissible",
  "fadeIn": "toast-module-scss-module__bXCbOq__fadeIn",
  "fadeOut": "toast-module-scss-module__bXCbOq__fadeOut",
  "label": "toast-module-scss-module__bXCbOq__label",
  "message": "toast-module-scss-module__bXCbOq__message",
  "toast": "toast-module-scss-module__bXCbOq__toast",
});
